<div class="round" *ngFor="let outcome of outcomes" [ngClass]="outcome.toLowerCase()"></div>

<div class="timeline-arrow"></div>
